"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isElementInViewport = void 0;
/**
 * Если часть DOM-элемента находится в области видимости, возвращает true. Иначе - false
 * @param el - DOM-element
 * @param viewPercent - число от 0 до 1, процент требуемой видимости блока
 */
const isElementInViewport = function (el) {
  let viewPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertBottomInView = rect.top - rect.height * viewPercent + rect.height >= 0;
  const vertTopInView = rect.top + rect.height * viewPercent <= windowHeight;
  const horLeftInView = rect.left + rect.width * viewPercent <= windowWidth;
  const horRightInView = rect.left - rect.width * viewPercent + rect.width >= 0;
  return vertBottomInView && horRightInView && vertTopInView && horLeftInView;
};
exports.isElementInViewport = isElementInViewport;